import type { RootState } from 'state';
import type { RoutesState } from '../slice';

function getUpdatingProps(state: RootState): [RoutesState['updating'], RoutesState['updatingKey']] {
  const { updating, updatingKey } = state.flightRoutes.routes;
  return [updating, updatingKey];
}

export default getUpdatingProps;
